import {Formik, Form, FormikHelpers} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addNFCtoTeamLeader, getTeamLeaderNFC} from './api'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'
import {TeamLeaderBase} from './type'
import {NFCCreate} from '../../../types/type'
import {RunnerBall} from '../../../components/FormLoader'
import {useQuery} from 'react-query'

function NFC({
  initialValues: teamLeaderDetails,
  onAfterSubmit,
}: {
  initialValues?: TeamLeaderBase
  onAfterSubmit: () => void
}) {
  const {data, isFetching: isFetchingNFC} = useQuery(
    ['teamLeaderNFC', teamLeaderDetails?.teamleader_id],
    () => getTeamLeaderNFC(teamLeaderDetails?.teamleader_id!),
    {
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  const submitHandler = (
    values: Omit<NFCCreate, 'type'>,
    {setSubmitting: setLoading}: FormikHelpers<any>
  ) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addNFCtoTeamLeader({
      id: values.id,
      type: 'team_leader',
      nfc_code: values.nfc_code,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err: any) => {
        handleApiError(err, toastId)
      })
      .finally(() => setLoading(false))
  }
  if (isFetchingNFC) {
    return <RunnerBall />
  }
  return (
    <div className="px-5 py-3">
      <Formik<Omit<NFCCreate & {team_leader_name: string}, 'type'>>
        initialValues={{
          id: teamLeaderDetails!.teamleader_id,
          team_leader_name: teamLeaderDetails!.name,
          nfc_code: data?.data!.nfc_code || '',
        }}
        validationSchema={Yup.object({
          nfc_code: Yup.string()
            .trim()
            .required('RFID is required')
            .notOneOf([''], 'RFID is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              label="Team Leader Name"
              name="team_leader_name"
              disabled
            />
            <FormikControl
              control="input"
              required
              placeholder="RFID"
              label="RFID"
              name="nfc_code"
            />
            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!dirty || !isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default NFC
